import PlanDelete from './PlanDelete.vue'
export { PlanDelete }
export default PlanDelete
